import { JobMatchesQueryFilter } from "../../../models/jobMatchesQueryFilter";
export class CandidateWorkflowPageController {
    /*@ngInject*/
    constructor($rootScope, stateManagementStorageService) {
        this.$rootScope = $rootScope;
        this.stateManagementStorageService = stateManagementStorageService;
    }
    $onInit() {
        this.$stateParams = this.$transition$.params();
        this.userId = this.$rootScope.userDetails.id;
        this.jobId = _.isNull(this.$stateParams.jobId) ? '' : this.$stateParams.jobId;
        this.reqStateData = _.isNull(this.$stateParams.reqStateData) ? '' : this.$stateParams.reqStateData;
        this._setGlobalFilters();
    }
    _setGlobalFilters() {
        let filter = new JobMatchesQueryFilter();
        let savedFilters = this.stateManagementStorageService.getScreenState(`candidateWorkflowScreen-${this.userId}`);
        if (savedFilters && !_.isEmpty(savedFilters)) {
            this.globalQueryFilterObject = _.cloneDeep(savedFilters);
            this.globalQueryFilterObject.jobMatchIds = [];
        }
        else {
            this.globalQueryFilterObject = new JobMatchesQueryFilter();
            this.stateManagementStorageService.setScreenState(`candidateWorkflowScreen-${this.userId}`, filter);
        }
        if (!_.isNull(this.$stateParams.searchString)) {
            this.globalQueryFilterObject.searchString = this.$stateParams.searchString;
        }
        if (!_.isNull(this.$stateParams.jobMatchId)) {
            this.globalQueryFilterObject.jobMatchIds.push(this.$stateParams.jobMatchId);
        }
        if (!_.isNull(this.$stateParams.visibilityFiltersObject)) {
            this.globalQueryFilterObject.isUnassigned = (!_.isNull(this.$stateParams.visibilityFiltersObject.isUnassigned)) && (this.$stateParams.visibilityFiltersObject.isUnassigned);
            this.globalQueryFilterObject.isAssignedToOthers = (!_.isNull(this.$stateParams.visibilityFiltersObject.isAssignedToOthers)) && (this.$stateParams.visibilityFiltersObject.isAssignedToOthers);
            this.globalQueryFilterObject.isAssignedToMe = (!_.isNull(this.$stateParams.visibilityFiltersObject.isAssignedToMe)) && (this.$stateParams.visibilityFiltersObject.isAssignedToMe);
        }
        else {
            this.globalQueryFilterObject.isUnassigned = true;
            this.globalQueryFilterObject.isAssignedToOthers = true;
            this.globalQueryFilterObject.isAssignedToMe = true;
        }
    }
}
CandidateWorkflowPageController.$inject = ['$rootScope', 'stateManagementStorageService'];
// import * as TEMPLATE from './candidate-job-matches-workflow-page.html';
import * as TEMPLATE from 'raw-loader!./candidate-job-matches-workflow-page.html';
export const CandidateWorkflowPageComponent = {
    selector: 'candidateJobMatchesWorkflowPage',
    component: {
        bindings: { $transition$: '<' },
        // templateUrl: 'app/partials/missioncontrol/candidateJobMatchesWorkflow/candidate-job-matches-workflow-page.html',
        template: TEMPLATE.default,
        controller: CandidateWorkflowPageController
    }
};
//# sourceMappingURL=candidate-job-matches-workflow-page.component.js.map